// extracted by mini-css-extract-plugin
export default {"pageWrap":"kc-z","fullWidth":"lc-z","heading":"mc-z","fullBleed":"nc-z","hidden":"oc-z"};